const POURCENTAGE_SIZE = 1.4;

export default POURCENTAGE_SIZE;
